import { useEffect, useState } from 'react';
import { Delete, Loader2 } from 'lucide-react';

const PAD = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const PinPad = ({ onComplete, loading, shake, testId = 'pin' }) => {
  const [pin, setPin] = useState('');
  useEffect(() => { if (pin.length === 6 && !loading) { onComplete(pin); setPin(''); } }, [pin]); // eslint-disable-line react-hooks/exhaustive-deps
  const press = (d) => { if (!loading) setPin((p) => (p.length >= 6 ? p : p + d)); };
  const cls = 'h-14 rounded-md text-2xl font-semibold bg-white border border-zinc-200 hover:bg-zinc-100 active:scale-95 transition disabled:opacity-50';
  return <div>
    <div className={`flex justify-center gap-3 mb-8 transition-transform ${shake ? 'animate-[shake_0.4s_ease-in-out]' : ''}`} data-testid={`${testId}-dots`}>
      {Array.from({ length: 6 }).map((_, i) => <div key={i} className={`w-3.5 h-3.5 rounded-full transition-all ${i < pin.length ? 'bg-zinc-950 scale-110' : 'bg-zinc-200'}`} />)}
    </div>
    <div className="grid grid-cols-3 gap-2.5">
      {PAD.map((d) => <button key={d} type="button" onClick={() => press(d)} disabled={loading} data-testid={`${testId}-${d}`} className={cls}>{d}</button>)}
      <div />
      <button type="button" onClick={() => press('0')} disabled={loading} data-testid={`${testId}-0`} className={cls}>0</button>
      <button type="button" onClick={() => setPin((p) => p.slice(0, -1))} disabled={loading || !pin.length} data-testid={`${testId}-backspace`} className={`${cls} flex items-center justify-center disabled:opacity-30`}><Delete className="h-4 w-4" /></button>
    </div>
    {loading && <div className="mt-6 flex items-center justify-center text-zinc-400 text-sm"><Loader2 className="h-4 w-4 animate-spin mr-2" /> Vérification…</div>}
    <style>{`@keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}`}</style>
  </div>;
};
